const Gap = {
  MOBILE: 24,
  DESKTOP: 35,
};

const breakpoint599 = window.matchMedia('(max-width: 599px)');
const breakpoint767 = window.matchMedia('(max-width: 767px)');
const breakpoint1023 = window.matchMedia('(max-width: 1023px)');
const breakpoint1239 = window.matchMedia('(max-width: 1239px)');

const calculateSlidesGap = () => document.documentElement.clientWidth > 767 ? Gap.DESKTOP : Gap.MOBILE;

const calculateSlidesPerView = () => {
  if (document.documentElement.clientWidth > 1239) {
    return 4;
  } else if (document.documentElement.clientWidth > 1023) {
    return 3;
  } else if (document.documentElement.clientWidth > 599) {
    return 2;
  } else {
    return 1;
  }
};

const initSliderDealers = () => {
  const sliders = document.querySelectorAll('.slider-dealers');

  if (!sliders.length) {
    return;
  }

  sliders.forEach((slider) => {
    const container = slider.querySelector('.slider-dealers__container');
    const slides = container.querySelectorAll('.slider-dealers__slide');
    const controls = slider.querySelector('.slider-dealers__controls');
    const navBtns = controls.querySelector('.slider-dealers__nav-btns');
    const prevBtn = navBtns.querySelector('.nav-btn--prev');
    const nextBtn = navBtns.querySelector('.nav-btn--next');
    const paginationElem = controls.querySelector('.slider-dealers__pagination');
    const navigation = {
      prevEl: prevBtn,
      nextEl: nextBtn,
    };
    const pagination = {
      el: paginationElem,
      bulletClass: 'slider-dealers__pagination-bullet',
      bulletActiveClass: 'slider-dealers__pagination-bullet--active',
    };

    const checkIfNeedNavigation = () => {
      const gap = calculateSlidesGap();
      const slideWidth = slides[0].offsetWidth;
      const slidesLength = slides.length * (slideWidth + gap) - gap;

      return slidesLength > slider.offsetWidth + 1;
    };

    let swiper;
    let slidesPerView = calculateSlidesPerView();
    let isNeedNavigation = checkIfNeedNavigation();

    const initSwiper = () => {
      // eslint-disable-next-line no-undef
      swiper = new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: Gap.MOBILE,
        grabCursor: true,
        pagination: isNeedNavigation ? pagination : false,
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          600: {
            slidesPerView,
            pagination: isNeedNavigation ? pagination : false,
          },
          768: {
            slidesPerView,
            spaceBetween: Gap.DESKTOP,
            pagination: false,
            navigation: slides.length > slidesPerView ? navigation : false,
          },
        },
      });

      if (slides.length > slidesPerView || isNeedNavigation) {
        slider.classList.remove('slider-dealers--low-content');
        navBtns.style.display = null;
      } else {
        slider.classList.add('slider-dealers--low-content');
        navBtns.style.display = 'none';
      }

      if (isNeedNavigation) {
        paginationElem.style.display = null;
      } else {
        paginationElem.style.display = 'none';
      }
    };

    const reInitSwiper = () => {
      slidesPerView = calculateSlidesPerView();

      if (swiper) {
        swiper.destroy(true, true);
      }

      initSwiper();
    };

    const onWindowResize = () => {
      const checkResult = checkIfNeedNavigation();

      if (isNeedNavigation !== checkResult) {
        isNeedNavigation = checkResult;
        reInitSwiper();
      }
    };

    initSwiper();
    onWindowResize();

    breakpoint599.addListener(reInitSwiper);
    breakpoint767.addListener(reInitSwiper);
    breakpoint1023.addListener(reInitSwiper);
    breakpoint1239.addListener(reInitSwiper);

    window.addEventListener('resize', onWindowResize);
  });
};

export {initSliderDealers};
